module.exports = __webpack_public_path__ + "img/order_pending_guy.1d97bc4e.png";